import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { statusSchedule } from '../../view-agenda/view-agenda.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AgendaService } from '../../services/agenda.service';
import { LoadingModalComponent } from "../../../../../loading-modal/loading-modal.component";
import { AlertComponent } from "../../../../../alert/alert.component";
@Component({
  selector: 'app-editar-agendamento',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, LoadingModalComponent, AlertComponent],
  templateUrl: './editar-agendamento.component.html',
  styleUrls: ['./editar-agendamento.component.scss'],
})
export class EditarAgendamentoComponent  implements OnInit {
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  @Input() appointmentObject: any;
  @Output() closeModal: EventEmitter<void>  = new EventEmitter<void>();
  @Output() closeModalUpdate: EventEmitter<void> = new EventEmitter<void>();

  @Output() updateAppointment: EventEmitter<void> = new EventEmitter<void>();

  public statusSchedule = statusSchedule;
  public dataAppointment: any;
  public formAppointment!: FormGroup;
  public nome: number = 3;

  constructor(private readonly agendaService: AgendaService, private fb: FormBuilder) {
    
   }

  ngOnInit() {
    this.dataAppointment = new Object({
      ...this.appointmentObject
    })
    console.log(this.dataAppointment);
  }

  handleSubmit(){
    this.loadingComponent.activeLoading();

     this.agendaService.updateAppointment(this.dataAppointment).subscribe((response: any)=> {
      
      this.alertComponent.showAlert(response.data.message, 'success');

      this.loadingComponent.inactiveLoading();
      
      this.closeModalUpdate.emit();

      this.updateAppointment.emit();
     },(error: any)=> {
      console.log(error);
     })
  }

  getStatusEnum(status: keyof typeof statusSchedule): string{
      return this.statusSchedule[status];
  }

  handleCloseModal(){
    this.closeModal.emit();
  }
}
